var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetricSparkline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 108,
    height: 54.5418,
    viewBox: "0 0 108 54.5418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.54419 18.3782H0.669767C0.299865 18.3782 0 18.7574 0 19.2251V53.6949C0 54.1626 0.299865 54.5418 0.669767 54.5418H9.54419C9.91409 54.5418 10.214 54.1626 10.214 53.6949V19.2251C10.214 18.7574 9.91409 18.3782 9.54419 18.3782Z",
    fill: "#D3C9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7674 21.9353H12.893C12.5231 21.9353 12.2233 22.3145 12.2233 22.7822V53.6949C12.2233 54.1626 12.5231 54.5418 12.893 54.5418H21.7674C22.1373 54.5418 22.4372 54.1626 22.4372 53.6949V22.7822C22.4372 22.3145 22.1373 21.9353 21.7674 21.9353Z",
    fill: "#D3C9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9907 11.8569H25.1163C24.7464 11.8569 24.4465 12.2361 24.4465 12.7038V53.6949C24.4465 54.1626 24.7464 54.5418 25.1163 54.5418H33.9907C34.3606 54.5418 34.6605 54.1626 34.6605 53.6949V12.7038C34.6605 12.2361 34.3606 11.8569 33.9907 11.8569Z",
    fill: "#D3C9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.214 15.414H37.3395C36.9696 15.414 36.6698 15.7932 36.6698 16.2609V53.6949C36.6698 54.1626 36.9696 54.5418 37.3395 54.5418H46.214C46.5839 54.5418 46.8837 54.1626 46.8837 53.6949V16.2609C46.8837 15.7932 46.5839 15.414 46.214 15.414Z",
    fill: "#D3C9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4372 8.29984H49.5628C49.1929 8.29984 48.893 8.67902 48.893 9.14676V53.6949C48.893 54.1626 49.1929 54.5418 49.5628 54.5418H58.4372C58.8071 54.5418 59.107 54.1626 59.107 53.6949V9.14676C59.107 8.67902 58.8071 8.29984 58.4372 8.29984Z",
    fill: "#D3C9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6605 13.0426H61.7861C61.4162 13.0426 61.1163 13.4218 61.1163 13.8895V53.6949C61.1163 54.1626 61.4162 54.5418 61.7861 54.5418H70.6605C71.0304 54.5418 71.3302 54.1626 71.3302 53.6949V13.8895C71.3302 13.4218 71.0304 13.0426 70.6605 13.0426Z",
    fill: "#D3C9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8837 4.74277H74.0093C73.6394 4.74277 73.3395 5.12195 73.3395 5.58969V53.6949C73.3395 54.1626 73.6394 54.5418 74.0093 54.5418H82.8837C83.2536 54.5418 83.5535 54.1626 83.5535 53.6949V5.58969C83.5535 5.12195 83.2536 4.74277 82.8837 4.74277Z",
    fill: "#D3C9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.107 9.48553H86.2326C85.8627 9.48553 85.5628 9.86471 85.5628 10.3325V53.6949C85.5628 54.1626 85.8627 54.5418 86.2326 54.5418H95.107C95.4769 54.5418 95.7767 54.1626 95.7767 53.6949V10.3325C95.7767 9.86471 95.4769 9.48553 95.107 9.48553Z",
    fill: "#D3C9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.33 0H98.4558C98.0859 0 97.7861 0.37918 97.7861 0.846922V53.6949C97.7861 54.1626 98.0859 54.5418 98.4558 54.5418H107.33C107.7 54.5418 108 54.1626 108 53.6949V0.846922C108 0.37918 107.7 0 107.33 0Z",
    fill: "#D3C9FA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricSparkline);
export default __webpack_public_path__ + "static/media/metric-sparkline.8c9c5a79c1182678cd2674e73bb77826.svg";
export { ForwardRef as ReactComponent };